import { sizes } from '../sizing.js';
export const header = {
    background: 'default',
    boxShadow: {
        style: 'none',
    },
    color: 'secondary',
    height: sizes.x9,
    paddingTop: 'x0',
    paddingBottom: 'x0',
    paddingLeft: 'x4',
    paddingRight: 'x4',
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export const cell = {
    background: 'onGray',
    boxShadow: {
        alpha: 'full',
        style: 'inset',
        color: 'default',
    },
    color: 'default',
    height: sizes.x12,
    paddingTop: 'x0',
    paddingBottom: 'x0',
    paddingLeft: 'x4',
    paddingRight: 'x4',
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export const subRow = {
    background: 'default',
};
export const row = {
    background: 'onGray',
};
export const cellSizes = {
    standard: {
        height: sizes.x12,
    },
    compact: {
        height: sizes.x9,
    },
    relaxed: {
        height: sizes.x14,
    },
};
export const cellVariants = {
    text: {},
    numeric: {
        textAlign: 'right',
    },
    link: {},
    emphasisedLink: {},
    actions: {},
    custom: {},
    expansion: {},
};
export const rowStates = {
    hover: {
        background: 'default',
    },
    selected: {
        background: 'accent',
    },
};
export const subRowStates = {
    hover: {
        background: 'secondaryOnGray',
    },
};
//# sourceMappingURL=tables.js.map